import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Ag1ButtonBaseComponent } from '../ag1-button-base/ag1-button-base.component';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { Ag1TooltipDirective } from '../../directives/tooltip.directive';
import { RouterLink } from '@angular/router';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

@Component({
  selector: 'ag1-link',
  templateUrl: './ag1-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    NgClass,
    Ag1TooltipDirective,
    RouterLink,
    SentenceCasePipe,
  ],
})
export class Ag1LinkComponent extends Ag1ButtonBaseComponent {
  // logic implemented inside Ag1ButtonBaseComponent
  @Input()
  variant: 'primary' | 'secondary' = 'primary';

  get showLink(): boolean {
    return this.routerLink && !this.disabled;
  }

  get showButton(): boolean {
    return !this.routerLink || this.disabled;
  }
}
